import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=64353b8e&"
import script from "./NoticeDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports